"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _react = _interopRequireWildcard(require("react"));
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _StyleConfig = require("../utils/StyleConfig");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _SwitchConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Switch-concur_android.css") : void 0);
var _SwitchConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Switch-concur_default.css") : void 0);
var _SwitchConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Switch-concur_gateway.css") : void 0);
var _SwitchConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Switch-concur_ios.css") : void 0);
var _SwitchSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Switch-sap_fiori_3_dark.css") : void 0);
var _SwitchSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Switch-sap_fiori_3_hcb.css") : void 0);
var _SwitchSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Switch-sap_fiori_3_hcw.css") : void 0);
var _SwitchSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Switch-sap_fiori_3.css") : void 0);
var _SwitchSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Switch-sap_horizon_dark.css") : void 0);
var _SwitchSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Switch-sap_horizon_hcb.css") : void 0);
var _SwitchSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Switch-sap_horizon_hcw.css") : void 0);
var _SwitchSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Switch-sap_horizon.css") : void 0);
var _excluded = ["className", "classNameMap", "checked", "containerProps", "controlProps", "disabled", "handleProps", "hiddenLabel", "iconProps", "inputProps", "inputRef", "label", "labelProps", "stateLabels", "stateLabelProps", "onChange", "showIcon", "sliderProps", "size", "trackProps"];
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  concur_android: _SwitchConcur_android.default,
  concur_default: _SwitchConcur_default.default,
  concur_gateway: _SwitchConcur_gateway.default,
  concur_ios: _SwitchConcur_ios.default,
  sap_fiori_3_dark: _SwitchSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _SwitchSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _SwitchSap_fiori_3_hcw.default,
  sap_fiori_3: _SwitchSap_fiori_.default,
  sap_horizon_dark: _SwitchSap_horizon_dark.default,
  sap_horizon_hcb: _SwitchSap_horizon_hcb.default,
  sap_horizon_hcw: _SwitchSap_horizon_hcw.default,
  sap_horizon: _SwitchSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-switch';

/**
 * The **Switch** mimics a physical switch. It allows users to set individual features
 * (such as personalization or display settings) to either active or inactive.
 */

var Switch = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _classnames2, _classnames3;
  var addChildProps = (0, _react.useContext)(_AddChildPropsContext.default);
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(Switch, _props)) : _props;
  var className = props.className,
    classNameMap = props.classNameMap,
    checked = props.checked,
    containerProps = props.containerProps,
    controlProps = props.controlProps,
    disabled = props.disabled,
    handleProps = props.handleProps,
    hiddenLabel = props.hiddenLabel,
    iconProps = props.iconProps,
    inputProps = props.inputProps,
    inputRef = props.inputRef,
    label = props.label,
    labelProps = props.labelProps,
    stateLabels = props.stateLabels,
    stateLabelProps = props.stateLabelProps,
    onChange = props.onChange,
    showIcon = props.showIcon,
    sliderProps = props.sliderProps,
    size = props.size,
    trackProps = props.trackProps,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var labelId = (0, _useUniqueId.default)();
  var inputId = (0, _useUniqueId.default)();
  var stateLabelId = (0, _useUniqueId.default)();
  var _useState = (0, _react.useState)(checked),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    checkedState = _useState2[0],
    setCheckedState = _useState2[1];
  (0, _react.useEffect)(function () {
    setCheckedState(!!checked);
  }, [checked]);
  var classnames = _bind.default.bind(classNameMap);
  var classes = classnames(CSS_BLOCK, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--compact"), size !== 'lg'), className);
  var inputClasses = classnames("".concat(CSS_BLOCK, "__input"), inputProps === null || inputProps === void 0 ? void 0 : inputProps.className);
  var labelClasses = classnames("".concat(CSS_BLOCK, "__label"), (_classnames2 = {}, (0, _defineProperty2.default)(_classnames2, "".concat(CSS_BLOCK, "__label--screen-reader-only"), hiddenLabel), (0, _defineProperty2.default)(_classnames2, "".concat(CSS_BLOCK, "__label--").concat(size), size !== 'md'), _classnames2), labelProps === null || labelProps === void 0 ? void 0 : labelProps.className);
  var textClasses = classnames("".concat(CSS_BLOCK, "__text"), (_classnames3 = {}, (0, _defineProperty2.default)(_classnames3, "".concat(CSS_BLOCK, "__text--").concat(size), size !== 'md'), (0, _defineProperty2.default)(_classnames3, "".concat(CSS_BLOCK, "__text--disabled"), disabled), _classnames3), stateLabelProps === null || stateLabelProps === void 0 ? void 0 : stateLabelProps.className);
  var getAriaLabelledBy = function getAriaLabelledBy() {
    var ids = labelProps !== null && labelProps !== void 0 && labelProps.id ? labelProps.id : labelId;
    if (stateLabels) {
      ids += stateLabelProps !== null && stateLabelProps !== void 0 && stateLabelProps.id ? " ".concat(stateLabelProps.id) : " ".concat(stateLabelId);
    }
    return ids;
  };
  var handleChange = function handleChange(e) {
    setCheckedState(!checkedState);
    if (typeof onChange === 'function') {
      onChange(e, !checkedState);
    }
  };
  var offIconSizeMap = {
    lg: 'xs-plus',
    md: 'xs'
  };
  var onIconSizeMap = {
    lg: 'sm-minus',
    md: 'xs-plus'
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: classes,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    id: labelId
  }, labelProps, {
    className: labelClasses
  }), label), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, containerProps, {
    className: classnames("".concat(CSS_BLOCK, "__container"), containerProps === null || containerProps === void 0 ? void 0 : containerProps.className)
  }), stateLabels && /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    id: stateLabelId
  }, stateLabelProps, {
    className: textClasses
  }), checkedState ? stateLabels.active : stateLabels.inactive), /*#__PURE__*/_react.default.createElement("label", (0, _extends2.default)({}, controlProps, {
    className: classnames("".concat(CSS_BLOCK, "__control"), controlProps === null || controlProps === void 0 ? void 0 : controlProps.className),
    htmlFor: (inputProps === null || inputProps === void 0 ? void 0 : inputProps.id) || inputId
  }), /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
    id: inputId
  }, inputProps, {
    "aria-labelledby": getAriaLabelledBy(),
    checked: checkedState,
    className: inputClasses,
    disabled: disabled,
    ref: inputRef,
    type: "checkbox",
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, sliderProps, {
    className: classnames("".concat(CSS_BLOCK, "__slider"), sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.className)
  }), /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, trackProps, {
    className: classnames("".concat(CSS_BLOCK, "__track"), trackProps === null || trackProps === void 0 ? void 0 : trackProps.className)
  }), /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, handleProps, {
    className: classnames("".concat(CSS_BLOCK, "__handle"), handleProps === null || handleProps === void 0 ? void 0 : handleProps.className)
  }), showIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, iconProps, {
    ariaHidden: true,
    className: classnames("".concat(CSS_BLOCK, "__icon"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__icon--active"), checkedState), iconProps === null || iconProps === void 0 ? void 0 : iconProps.className),
    iconName: checkedState ? 'check' : 'minus-3',
    size: checkedState ? onIconSizeMap[size] : offIconSizeMap[size]
  }))))))));
});
Switch.displayName = 'Switch';
Switch.propTypes = {
  /** Text label for **Switch** input, use `hiddenLabel` prop to visually hide. */
  label: _propTypes.default.node.isRequired,
  /** When `true`, the **Switch** renders as `checked`. */
  checked: _propTypes.default.bool,
  /** Custom classes to be added to the wrapping `<div>` element.  */
  className: _propTypes.default.string,
  /** Additional props to spread to the container `<div>` element. */
  containerProps: _propTypes.default.object,
  /** Additional props to spread to the control `<label>` element. */
  controlProps: _propTypes.default.object,
  /** When `true`, the **Switch** will be disabled. */
  disabled: _propTypes.default.bool,
  /** Additional props to spread to the handle `<span>` element. */
  handleProps: _propTypes.default.object,
  /** When `true`, the label will not be shown. It will still be present with a
   * `screen-reader-only` class which allows it to be read to assistive technologies. */
  hiddenLabel: _propTypes.default.bool,
  /** Additional props to spread to the **Icon** component. */
  iconProps: _propTypes.default.object,
  /** Additional props to spread to the `<input>` element. */
  inputProps: _propTypes.default.object,
  /** Attaches a ref to the `<input>` element. */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /** Additional props to spread to the label `<span>` element. */
  labelProps: _propTypes.default.object,
  /** Set to **true** to display a check or minus icon inside the handle. */
  showIcon: _propTypes.default.bool,
  /** Additional props to spread to the slider `<span>` element. */
  sliderProps: _propTypes.default.object,
  /** Size of the element. Options are `'lg'`, `'md'`. */
  size: _propTypes.default.oneOf(_StyleConfig.CONTROL_SIZES),
  /** Set to display text next to the switch to indicate what the "active" and "inactive" states
  * mean in your specific use case. Keep the text succinct. */
  stateLabels: _propTypes.default.shape({
    active: _propTypes.default.string.isRequired,
    inactive: _propTypes.default.string.isRequired
  }),
  /** Additional props to spread to the optional text `<span>` element. */
  stateLabelProps: _propTypes.default.object,
  /** Additional props to spread to the track `<span>` element. */
  trackProps: _propTypes.default.object,
  /** Callback function for onChange events.
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param {boolean} checked
   */
  onChange: _propTypes.default.func
};
Switch.defaultProps = {
  size: 'lg',
  checked: false
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(Switch);
exports.default = _default;